export default __webpack_public_path__ + "static/media/mockups.b65e06b7.png";